import { useTranslation } from 'react-i18next'
import { clockTime, UserItem } from '../util/activity'

interface OperatorTurnProps { item: UserItem }

/** The operator's own turn. Rendered so the thread reads as a conversation rather than a
 *  monologue — the instruction plus the files that were attached with it. */
export function OperatorTurn({ item }: Readonly<OperatorTurnProps>) {
  const { t } = useTranslation()
  const time = clockTime(item.at)

  return (
    <div className="copilot-turn" data-testid="copilot-operator-turn">
      <div className="copilot-turn__who">
        <i className="fa fa-user" aria-hidden="true" />
        {t('copilot.turn.you')}
        {time && <span className="copilot-turn__time">{time}</span>}
      </div>
      <div className="copilot-turn__text">{item.text}</div>
      {item.files.length > 0 && (
        <ul className="copilot-turn__files">
          {item.files.map((f) => (
            <li key={f}><i className="fa fa-paperclip" aria-hidden="true" />{f}</li>
          ))}
        </ul>
      )}
    </div>
  )
}
